module.exports = __webpack_public_path__ + "img/sld_scb_4_t1_b1_dark.6f9a3f96.svg";